export const downloadFile = (
  filename: string,
  body: string | Blob | MediaSource
) => {
  const element = document.createElement('a');

  if (typeof body === 'string') {
    element.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(body);
  } else {
    element.href = window.URL.createObjectURL(body);
  }

  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};
